module.exports = __webpack_public_path__ + "img/電気回路_3_3.9df5ce06.png";